import React from 'react';
import { Typography as PdcTypography } from '@mzc-pdc/ui';
import { TypographyProps } from './infrastructures/TypographyProps';

export const H2 = (props: TypographyProps) => (
  <PdcTypography variant={'h2'} component={'h2'} align={props.centered ? 'center' : undefined}>
    {props.children}
  </PdcTypography>
);
